import { isSectionPart } from './partNumbers';

// A note (a "Note" part, or a "Hidden" one — a note only admins see) can be attached to one or
// more regular parts. An attached note stops being a part of its own: its text renders at the top
// of every part it was attached to, as if it had been typed into those lyrics. Attachment is stored
// on the note as a list of host part ids, so it targets those exact parts — a host's duplicates are
// separate parts and do not inherit it.
export const isNotePart = (part) => part.name === 'Note' || part.name === 'Hidden';

// Sections are titles rather than lyrics, and a note inside another note makes no sense
export const canAttachNotesTo = (part) => !isNotePart(part) && !isSectionPart(part);

export const getAttachedToPartIds = (part) => part.attachedToPartIds ?? [];

export const isAttachedToPart = (note, partId) => getAttachedToPartIds(note).includes(partId);

// Notes attached to `partId`, in the order they appear in the song
export const getAttachedNotes = (parts, partId) =>
  parts.filter((part) => isNotePart(part) && isAttachedToPart(part, partId));

// A note whose hosts have all been deleted has nowhere to render, so it falls back to standing
// on its own rather than disappearing from the song
export const isAttachedNote = (part, parts) =>
  isNotePart(part) && getAttachedToPartIds(part).some((id) => parts.some((p) => p.id === id));

export const countAttachedToParts = (note, parts) =>
  getAttachedToPartIds(note).filter((id) => parts.some((p) => p.id === id)).length;
